import { Badge } from 'antd';
import { observer } from 'mobx-react-lite';

import { EPhoneStatus } from '../../core/phone-status';

type PhoneStatusLabelProps = {
  status?: EPhoneStatus;
};

export const PhoneStatusLabel = observer(
  ({ status }: PhoneStatusLabelProps) => {
    if (status == undefined) return null;

    switch (status) {
      case EPhoneStatus.new:
        return (
          <Badge
            status="processing"
            text="Новый"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EPhoneStatus.confirmed:
        return (
          <Badge
            status="success"
            text="Подтвержден"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      case EPhoneStatus.codeSended:
        return (
          <Badge
            status="warning"
            text="Ожидает подтверждения"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
      default:
        return (
          <Badge
            status="default"
            text="Неизвестный статус"
            style={{ whiteSpace: 'nowrap' }}
          />
        );
    }
  }
);
